import { render, staticRenderFns } from "./SectionH1.vue?vue&type=template&id=3c6e81ba&scoped=true"
import script from "./SectionH1.vue?vue&type=script&lang=ts"
export * from "./SectionH1.vue?vue&type=script&lang=ts"
import style0 from "./SectionH1.vue?vue&type=style&index=0&id=3c6e81ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c6e81ba",
  null
  
)

export default component.exports